<!--Fibroscan-->
<script setup>
import { computed, reactive ,ref} from "vue";
import { useCrfStore } from "@/stores/crf";
import check from "./check.vue";

import {useCommonStore} from "@/stores/common.js"
const commonStore = useCommonStore()
//不是筛选期
let notScreen = ref(false)
notScreen.value = commonStore.funNotScreen

//是不是v0
let isv0 = ref(false)
isv0.value = commonStore.isV0

// 定义组件属性
const props = defineProps({
  formModel: {},
  type: null
});

// 表单对象
const model = reactive(props.formModel);
const crfStore = useCrfStore();

// 节省代码长度，在模板中使用
const crfFields = computed(() => {
  return model.fields[`${props.type}`];
});

// 字段自动校验用于赋值 prop
const itemProp = function(prop) {
  return `fields['${props.type}']['${prop}']`;
};
</script>
<template>
  <template v-if="crfFields">
    <div style="display: flex; align-items: center;">
      <h2>Fibrotouch</h2>
      <check :period="props.type" text="Fibrotouch" :data="model" v-if="model.checkdata.ischeck == '是'"></check>
    </div>
    <el-form-item label="Fibrotouch是否适用肝筛选期数据"  v-if="crfFields && isv0" class="redStar">
      <el-radio-group v-if="notScreen" v-model="crfFields['Fibrotouch是否适用肝筛选期数据']">
        <el-radio label="是" prop="是"></el-radio>
        <el-radio label="否" prop="否"></el-radio>
      </el-radio-group>
    </el-form-item>

    <template v-if="crfFields['Fibrotouch是否适用肝筛选期数据'] == '否' || !isv0">
      <el-form-item :label="notScreen?'是否新增Fibrotouch':'Fibrotouch'"  v-if="crfFields && notScreen" class="redStar">
          <el-radio-group v-if="notScreen" v-model="crfFields['是否新增Fibrotouch']">
            <el-radio label="是" prop="是"></el-radio>
            <el-radio label="否" prop="否"></el-radio>
          </el-radio-group>

      </el-form-item>
      <template v-if="crfFields['是否新增Fibrotouch'] == '是'">
          <el-form-item label="肝脏硬度(Kpa)" :prop="itemProp(`肝脏硬度Fibrotouch`)" :rules="crfStore.textRules(`Fibrotouch`,true)" class="redStar">
            <el-input v-model="crfFields['肝脏硬度Fibrotouch']" autocomplete="off"> <template #append>Kpa</template></el-input>
          </el-form-item>

          <el-form-item label="脂肪衰减度" :prop="itemProp(`脂肪衰减度`)" :rules="crfStore.textRules(`脂肪衰减度`,true)"  class="redStar">
            <el-input v-model="crfFields['脂肪衰减度']" autocomplete="off"></el-input>
          </el-form-item>
      </template>
      
    </template>

    <template v-if="!notScreen">
        <el-form-item label="是否做过Fibrotouch" class="redStar">
          <el-radio-group v-model="crfFields['是否做过Fibrotouch']">
            <el-radio label="是" prop="是"></el-radio>
            <el-radio label="否" prop="否"></el-radio>
          </el-radio-group>
        </el-form-item>
        <div v-if="crfFields['是否做过Fibrotouch'] == '是'">

          <el-form-item label="肝脏硬度(Kpa)" :prop="itemProp(`肝脏硬度Fibrotouch`)" :rules="crfStore.textRules(`Fibrotouch`,true)"  class="redStar">
            <el-input v-model="crfFields['肝脏硬度Fibrotouch']" autocomplete="off"> <template #append>Kpa</template></el-input>
          </el-form-item>

          <el-form-item label="脂肪衰减度" :prop="itemProp(`脂肪衰减度`)" :rules="crfStore.textRules(`脂肪衰减度`,true)"  class="redStar">
            <el-input v-model="crfFields['脂肪衰减度']" autocomplete="off"></el-input>
          </el-form-item>
        </div>
      </template>
  </template>
</template>

<style scoped>
</style>